<template>
  <div class="columns is-variable is-multiline">
    <div class="column is-half-tablet is-one-quarter-desktop">
      <FormSelect
        v-model="regionSelectValue"
        colour="oneXP"
        :has-filter="false"
        :initial-option="
          regionSelectOptions.indexOf(regionSelectValue) > 0
            ? regionSelectValue
            : regionSelectOptions[0]
        "
        :label="config.regionLabel"
        :options="regionSelectOptions"
        @update="updateCountries"
      />
    </div>
    <div class="column is-half-tablet is-one-quarter-desktop">
      <FormSelect
        :key="`countryKey-${regionSelectValue}`"
        v-model="countrySelectValue"
        colour="oneXP"
        :has-filter="false"
        :initial-option="
          countrySelectOptions.indexOf(countrySelectValue) > 0
            ? countrySelectValue
            : countrySelectOptions[0]
        "
        :label="config.countryLabel"
        :options="countrySelectOptions"
        @update="updateContacts"
      />
    </div>
  </div>
  <div class="columns is-variable is-multiline">
    <div
      v-for="(result, resultIndex) in contacts"
      :key="`${result.title}${resultIndex}`"
      class="column is-half-tablet is-one-quarter-desktop"
    >
      <ListTeaser is-address-teaser :result="result" :use-form="useForm" />
    </div>
  </div>
</template>

<script setup>
import FormSelect from '../FormSelect/FormSelect.vue';
import ListTeaser from '../ListTeaser/ListTeaser.vue';
import { regionDataUrl } from '../../shared/globals';
import { onMounted, ref } from 'vue';
import safeFetch from '../../utils/safeFetch';

const props = defineProps({
  config: {
    type: Object,
    default: () => {},
  },
  useForm: {
    type: Boolean,
    default: false,
  },
});

const apiData = ref(null);
const contacts = ref([]);
const regionSelectOptions = ref([]);
const regionSelectValue = ref('');
const countrySelectOptions = ref([]);
const countrySelectValue = ref('');

const wtTrack = window.wtTrack;

const getContacts = (url) => {
  return safeFetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => (contacts.value = data.contacts))
    .catch((error) => console.error(error));
};

const updateContacts = (valueRaw) => {
  const value = Array.isArray(valueRaw) ? valueRaw[0] : valueRaw;
  wtTrack({ cat: 'SALESBOXCLICK' }, { inputIdent: `${regionSelectValue.value} - ${value}` });
  countrySelectValue.value = value;

  for (let region of apiData.value.regions) {
    if (region.name === regionSelectValue.value) {
      for (let country of region.countries) {
        if (country.name === value) {
          getContacts(country.contacts);
        }
      }
    }
  }
};

const initApiData = (data) => {
  apiData.value = data;
  regionSelectValue.value = props.config.currentRegion;
  countrySelectValue.value = props.config.currentCountry;

  for (let region of apiData.value.regions) {
    regionSelectOptions.value.push(region.name);

    if (region.name === props.config.currentRegion) {
      for (let country of region.countries) {
        countrySelectOptions.value.push(country.name);

        if (country.name === props.config.currentCountry) {
          getContacts(country.contacts);
        }
      }
    }
  }
};

const updateCountries = (valueRaw) => {
  const value = Array.isArray(valueRaw) ? valueRaw[0] : valueRaw;
  regionSelectValue.value = value;

  for (let region of apiData.value.regions) {
    if (region.name === value) {
      countrySelectValue.value = region.countries.some(
        (country) => country.name === props.config.currentCountry,
      )
        ? props.config.currentCountry
        : region.countries[0].name;
      countrySelectOptions.value.length = 0;

      const selectedCountryIndex = region.countries.findIndex(
        (country) => country.name === countrySelectValue.value,
      );

      for (let country of region.countries) {
        countrySelectOptions.value.push(country.name);
      }
      getContacts(
        selectedCountryIndex
          ? region.countries[selectedCountryIndex]?.contacts
          : region.countries[0].contacts,
      );
    }
  }
};

onMounted(() => {
  let dataUrl;

  dataUrl = window.regionDataUrl ? window.regionDataUrl : regionDataUrl;
  safeFetch(dataUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => initApiData(data))
    .catch((error) => console.error(error));
});
</script>
